import { config } from '@services/config';
import { UserRolesGetResponse } from '@lio/api-types';
import { useOktaAuth } from '@okta/okta-react';
import { userQueryKey } from '@services/user/keys';
import { useQuery } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';

export const useCurrentUserRole = () => {
  const { authState } = useOktaAuth();
  const client = useClient();
  const result = useQuery<UserRolesGetResponse, Error>({
    queryKey: userQueryKey.currentUserRole,
    queryFn: async () => client.get('user/current/role').json<UserRolesGetResponse>(),
    refetchOnMount: (query) => query.state.status !== 'error',
    refetchOnWindowFocus: (query) => query.state.status !== 'error',
    retry: false,
    enabled: !!authState?.isAuthenticated,
    ...config,
  });
  return { ...result, currentUserRole: result.data };
};
